import React, { Suspense } from "react";
import Routes from "./routes/Router";
import Loader from "./components/loader/Loader";
import Spinner from "./components/Spinner/Spinner";
import Toaster from "./components/Toaster/Toaster";

const App = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes />
      <Spinner />
      <Toaster />
    </Suspense>
  );
};

export default App;
